import { usePromotion } from '@mc/promo-utils'

export const useGiftEnabled = () => {
  const { variables } = usePromotion()
  const giftEnabled = variables?.gift_eligible?.toString() === 'true'

  return { giftEnabled }
}
